module.exports = __webpack_public_path__ + "img/3d-model_jp.43f9fae.jpg";